angular.module( 'acme.view.application.layouts.membership', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.membership.cards',
  'acme.view.application.layouts.membership.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsMembership = {
        name: 'application.layouts.membership',
        url: '/membership',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'LayoutsMembershipController',
            templateUrl: 'views/application/views/layouts/membership/membership.tpl.html'
          }
        },
        data: {
          pageTitle: 'Membership Card Layouts',
          permissions: ['MEMBERSHIP_CARD_LAYOUTS_VIEW']
        }
      };

    $stateProvider
      .state(layoutsMembership);
});
